import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { MarketingVoucherEditNewContainer } from "@/components/features/marketing/voucher/edit";

import { useGetVoucherEditPageParams } from "./_hooks/use-get-voucher-edit-page-params";

export const MarketingNewVoucherEditPage = () => {
	const { hotelID, duplicateItemID } = useGetVoucherEditPageParams();

	return (
		<PageMeta title="新しい宿泊券の作成" url={generatePath(PATHS.HOTEL.MARKETING.VOUCHER.NEW, { hotelID })}>
			<MarketingVoucherEditNewContainer hotelID={hotelID} duplicateItemID={duplicateItemID} />
		</PageMeta>
	);
};

MarketingNewVoucherEditPage.displayName = "MarketingNewVoucherEditPage";
